import React, {
  ComponentType,
  useState
} from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import {
  Button,
  Form,
  Modal,
  Responsive
} from 'semantic-ui-react'
// Local
import {
  MOBILE_WIDTH,
  shouldRenderReskin2025,
  TABLET_WIDTH
} from '../../constant'
import { submitFeedback } from '../../action/feedback'
// Styling
import './index.css'
import If from '../common/if'
import ReveleerButton from '../common/ReveleerButton'
import { RootState } from '../../store'

const SafeForm = Form as unknown as ComponentType<any>

const mapStateToProps = (state: RootState) => ({
  reduxState: state
})

const mapDispatchToProps = (dispatch: Dispatch<any>) => ({
  submitFeedbackProp: (
    comment: string,
    state: RootState
  ) => dispatch(submitFeedback(comment, state))
})

type ReduxStateProps = ReturnType<typeof mapStateToProps>
type ReduxDispatchProps = ReturnType<typeof mapDispatchToProps>

type Props = ReduxStateProps & ReduxDispatchProps

/**
 * TODO - sboles - refactor this so it is has some idea of the context that it
 * is working in. Having to detect an encounter ID from redux state sucks.
 */
function Feedback(
  props: Props
): JSX.Element {
  const {
    reduxState,
    submitFeedbackProp
  } = props
  const [
    isOpenState,
    setIsOpenState
  ] = useState<boolean>(false)

  const [
    formState,
    setFormState
  ] = useState<string>('')

  const clickFeedback = () => {
    setIsOpenState(true)
    setFormState('')
  }

  const closeModal = () => {
    setIsOpenState(false)
  }

  const updateField = (
    e: any,
    { value }: { name: string, value: string }
  ) => {
    setFormState(value)
  }

  const submit = () => {
    submitFeedbackProp(
      formState,
      reduxState
    )
    setIsOpenState(false)
  }

  return (
    <div id="feedback">
      <Responsive
        as={ Button }
        className="feedback"
        content="Feedback"
        icon="comments"
        color="black"
        onClick={ clickFeedback }
      />
      <Modal
        closeIcon
        open={ isOpenState }
        onClose={ closeModal }
      >
        <Responsive
          as={ Modal.Header }
          minWidth={ TABLET_WIDTH.minWidth }
        >
          Please provide any clinical or technical feedback here, omitting PHI.
          For urgent matters, please reach out directly to a member of Curation Health.
        </Responsive>
        <Responsive
          as={ Modal.Header }
          maxWidth={ MOBILE_WIDTH.maxWidth }
        >
          How can we help?&nbsp;&nbsp;&nbsp;What can we do better?
        </Responsive>
        <Modal.Content>
          <SafeForm onSubmit={ submit }>
            <Form.TextArea
              name="comment"
              value={ formState }
              placeholder="Type your message..."
              onChange={ updateField }
            />
            <If isTrue={ !shouldRenderReskin2025 }>
              <Button
                id="feedback-form-submit-button"
                type="submit"
                color="blue"
              >
                Submit
              </Button>
            </If>
            <If isTrue={ shouldRenderReskin2025 }>
              <ReveleerButton
                buttonLabel="Submit"
                buttonSize="small"
                buttonType="primary"
                id="feedback-form-submit-button"
                isDisabled={ false }
                onClick={ undefined }
                type="submit"
              />
            </If>
          </SafeForm>
        </Modal.Content>
      </Modal>
    </div>
  )
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Feedback)
